import axios from 'axios';
import {REP_API_URL} from '../utils/constants.js';

class SalesTrendingReportService {
    
    async getCustomerBySales(data) {
        const url = `${REP_API_URL}get-customer-by-sales`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});

    }

	async getTotalSales(data) {
        const url = `${REP_API_URL}get-total-sales`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});

    }

	async getCategorySales(data) {
        const url = `${REP_API_URL}get-category-sales`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});

    }

	async getCustomerSales(data) {
        const url = `${REP_API_URL}get-customer-sales`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});

    }

	async getTopCustomers(data) {
        const url = `${REP_API_URL}get-top-customers`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});

    }

	async getNewCustomerSales(data) {
        const url = `${REP_API_URL}get-new-customer-sales`;
		//const url = `http://127.0.0.1:8000/rep-portal-api/get-new-customer-sales/`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});

    }

	async getDormantCustomers(data) {
        const url = `${REP_API_URL}get-dormant-customers`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});

    }

	async getAgencies(data) {
        const url = `${REP_API_URL}get-agencies`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});

    }

	async exportSalesTrendingPdf(payload) {
		const url = `${REP_API_URL}export-sales-trending-pdf/`;
		//const url = `http://127.0.0.1:8000/rep-portal-api/export-sales-trending-pdf/`;
		const headers = {
			'Content-Type': 'application/json',
		};
	
		return axios({
			url: url,
			method: 'post',
			responseType: 'blob',
			headers: headers,
			data:payload
		})
		.then(function (response) {
			return response;
		})
		.catch(function (error) {
			return error.response ? error.response.data : { error: 'Unknown error' };
		});
	}

	async exportSalesTrendingExcel(payload) {
		const url = `${REP_API_URL}export-sales-trending-excel/`;
		//const url = `http://127.0.0.1:8000/rep-portal-api/export-sales-trending-excel/`;
		const headers = {
			'Content-Type': 'application/json',
		};
	
		return axios({
			url: url,
			method: 'POST',
			responseType: 'blob',
			headers: headers,
			data: payload
		})
		.then(function (response) {
			return response;
		})
		.catch(function (error) {
			return error.response ? error.response.data : { error: 'Unknown error' };
		});
	}

	async shareSalesTrendingReport(payload) {
		const url = `${REP_API_URL}share-sales-trending-report/`;
		//const url = `http://127.0.0.1:8000/rep-portal-api/share-sales-trending-report/`;
		const headers = {
			'Content-Type': 'application/json',
		};
	
		return axios({
			url: url,
			method: 'POST',
			headers: headers,
			data: payload
		})
		.then(function (response) {
			return response;
		})
		.catch(function (error) {
			return error.response ? error.response.data : { error: 'Unknown error' };
		});
	}
}

export default SalesTrendingReportService;